function addPageClassToBody() {


  // Get the current URL
  const currentUrl = window.location.href;

  // Create a URL object
  const url = new URL(currentUrl);

  // Get the pathname (everything after the domain)
  const pathname = url.pathname;

  // Split the pathname into segments and get the last segment
  const segments = pathname.split('/').filter((segment) => segment.length > 0);
  const lastSegment =
    segments.length > 0 ? segments[segments.length - 1] : 'home';

  // Sanitize the last segment to be a valid CSS class name
  const sanitizedSegment = lastSegment.replace(/[^a-zA-Z0-9\-_]/g, '-');


  // Add the sanitized segment as a class to the body element
  document.body.classList.add('page-'+sanitizedSegment);
}

export default addPageClassToBody